import React from "react";

const WorkflowSheet = ({ wfSheetData, formatDueDeliveryDate, isVisible }) => {
  return (
    <div
      id="work-flow-sheet"
      className={`border-gray border px-8 pb-3 pt-4 m-auto rounded-3xl relative ${
        !isVisible ? "hidden" : ""
      }`}
      style={{
        width: "559px", // A6 fixed width
        minHeight: "auto", // Allows height to adjust dynamically
        backgroundColor: "white",
        overflow: "hidden",
        pageBreakInside: "avoid", // Ensures no split
        breakInside: "avoid",
      }}
    >
      <div className="flex items-start justify-between gap-2 font-interBold">
        <div>
          <p className="text-2xl text-gray-600 mb-2">
            {wfSheetData?.dentistName}
          </p>
          <p className="text-2xl text-gray-600 mb-2">
            {wfSheetData?.patientName}
          </p>
          <p className="text-2xl text-gray-600 mb-2">
            {wfSheetData?.workTypeName}
          </p>
        </div>
        <div className="flex items-center justify-end text-gray-500 w-40">
          <p className="text-2xl text-gray-600 font-interBold mb-0">
            {wfSheetData?.geoCode}
          </p>
        </div>
      </div>

      <hr className="border-gray my-2" />

      <div style={{ breakInside: "avoid", pageBreakInside: "avoid" }}>
        {wfSheetData?.departments?.map((item, index) => (
          <div
            key={index}
            className={`flex items-center justify-between gap-2 font-inter`}
            style={{
              breakInside: "avoid", // Prevents breaking inside rows
              pageBreakInside: "avoid",
              marginBottom:
                index === wfSheetData.departments.length - 1 ? "6px" : "11px", // Last row spacing fix
            }}
          >
            <p className="text-2xl text-gray-700">{item.departmentName}</p>
            <div className="w-35 text-right flex text-2xl text-gray-600 font-interRegular">
              <p>{formatDueDeliveryDate(item.dueDateTime)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkflowSheet;
